let update_pwd = require("../../templates/pos/settings/updatePwd.handlebars");

let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
import POS from "../../POS.js";
import ModalView from "../comp/ModalView.js";
import i18n from "../../utils/i18n";
let HB = require("handlebars");
let DbRecorder = require("../../recorder/DbRecorder.js");
import PrinterConverterUtil from"../../utils/PrinterConverterUtil.js";
import PrintService from"../../service/PrintService.js";
let moment = require("moment");

let main = function () {
    var MembershipModalView = ModalView.extend({
        events: {
            "click .setPWD": "_setPwd",
            "click .btn-close": "_close",
            'click .close': "_closeMemberModal",
            "click .confirm-btn": "_confirmPwd",
            "click .btn-confirm": "_confirm",
            'click .delete': '_deleteMembership'

        },
        _confirm: function () {
            this.trigger("confirm");
        },
        _setPwd: function () {
            var self = this;
            self.$('.setModal').modal("show");
            return false;
        },
        _confirmPwd: function () {
            var self = this, pwd = self.$(".pwd-input").val(), rePwd = self.$(".rpwd-input").val();
            if (pwd.length < 6) {
                self.$(".re-input").text(i18n.msg('pos.setting.membership.pwd.length'));
                self.$(".pwd-required").show();
                return;
            }
            if (pwd != rePwd) {
                self.$(".re-input").text(i18n.msg('pos.setting.membership.pwd.confirm'));
                self.$(".pwd-required").show();
                return;
            }
            self.$('.paymentPassword').val(pwd);
            self.$('.setModal').modal("hide");
            self.$(".pwd-required").hide();
        },
        _closeMemberModal: function () {
            var self = this;
            self._close();
        },
        _close: function () {
            var self = this;
            self.$('.setModal').modal("hide");
            self.$(".pwd-input").val("");
            self.$(".rpwd-input").val("");
            self.$(".pwd-required").hide();
        },
        _deleteMembership: function () {
            this.trigger("delete");
        },
        showFieldError: function (errors) {
            console.log('show error!');
            var self = this;
            _.each(errors, function (v, f) {


                if (f == 'name' || self.$(".field." + f).size() == 0) {
                    self.$(".field.errorMsg").addClass('error').find(".help-block").text(v);
                } else {
                    _.each(self.$(".field"), function (field, index) {
                        $(field).removeClass('error').find(".help-block").text("");
                    });
                    self.$(".field." + f).addClass('error').find(".help-block").text(v);
                }
            });
        }
    });

    return Backbone.View.extend({
        events: {
            'click .search': '_search',
            'click .membership-charge': '_createCharge',
            'click .membership-deduct': '_createDeduct',
            'click .send-coupon': '_createCoupon',
            'click .disuse-membership': '_disuseMembership',
            'click .topupModal .cancel': '_closeModal',
            'click .topupModal .save': '_saveTopup',
            'click .couponModal .submit-coupon': '_submitCoupon',
            'change .couponModal .target-select': '_changeTargetType',
            'change .topupModal .credit-select': '_changeTopupType',
            'click .deductModal .cancel': '_closeDeductModal',
            'click .deductModal .save': '_saveDeduct',
            'change .deductModal .credit-select': '_changeDeductType',
            'click .memberList .nav li:not(.add-member)': '_changeTabPanel',
            'click .createMembership': '_createMembership',
            'click .charge-print': '_rePrintCharge',
            'click .expend-print': '_rePrintExpend',
            'click .basic-panel .navbar-btn': '_listMembership',
            'click .consume-panel .navbar-btn': '_listExpenditureHistory',
            'click .charge-panel .navbar-btn': '_listRechargeHistory',
            'click .rebate-panel .navbar-btn': '_listRebateHistory',
            'click .deduct-panel .navbar-btn': '_listDeductHistory',
            'click .chargeSort': "_rechargeHistorySortByName",
            'click .membership-tr td:not(:last-child)': "_updateMembership",
            'click .dropdown .update': "updatePwd",
            'click .dropdown .reset': "resetPwd",
            'click .dropdown .config': "configPwd",
            'click .updateModal .btn-close': "_closeUpdateModal",
            'click .updateModal .confirm-btn': "_confirmUpdate",
            'click .recommend-membership-btn': '_recommendMembership'
        },

        render: function () {
            var self = this;
            $.post('/pos/settings', {section: "membership"}, function (response) {
                self.$el.html(response);
                self._changeTabPanel();
            });
        },
        configPwd: function (evt) {
            var self = this, id = self.$(evt.currentTarget).closest(".membership-tr").data("id");
            var el = update_pwd({id: id, haspwd: false});
            self.$(".updateModal .modal-body").empty().append(el);
            self.$('.updateModal').find('.modal-content').addClass("settingsModal");
            self.$('.updateModal').modal("show");
            return false;
        },
        resetPwd: function (evt) {
            var self = this, id = self.$(evt.currentTarget).closest(".membership-tr").data("id");
            var url = "/membership/clearPassword", jxhr;
            if (confirm(i18n.msg('pos.setting.membership.pwd.reset.confirm'))) {
                POS.showLoading(true);
                jxhr = $.post(url, {id: id});
                jxhr.done(function (response) {
                    if (response.success) {
                        alert(i18n.msg('pos.setting.membership.pwd.reset.success'));
                        self._listMembership();
                    }
                });
                jxhr.fail(function (response) {

                });
                jxhr.always(function () {
                    POS.showLoading(false);
                });
            }
        },
        updatePwd: function (evt) {
            var self = this, id = self.$(evt.currentTarget).closest(".membership-tr").data("id");
            var el = update_pwd({id: id, showOld: true, haspwd: true});
            self.$(".updateModal .modal-body").empty().append(el);
            self.$('.updateModal').modal("show");
            return false;
        },
        _confirmUpdate: function () {
            var self = this, oPwd = self.$(".o-input").val(), nPwd = self.$(".n-input").val(),
                id = self.$(".create-form").data("id"), haspwd = self.$(".create-form").data("haspwd"),
                rPwd = self.$(".r-input").val(), url = haspwd == true ? "/membership/resetPassword" : "/membership/setPassword", jxhr;
            if (nPwd.length < 6) {
                self.$(".create-form .re-input").text(i18n.msg('pos.setting.membership.pwd.length'));
                self.$(".create-form .pwd-required").show();
                return;
            }
            if (nPwd != rPwd) {
                self.$(".create-form .re-input").text(i18n.msg('pos.setting.membership.pwd.confirm'));
                self.$(".create-form .pwd-required").show();
                return;
            }
            if (haspwd) {
                POS.showLoading(true);
                jxhr = $.post("/membership/checkPassword", {id: id, password: oPwd});
                jxhr.done(function (response) {
                    if (response.result) {
                        jxhr = $.post(url, {id: id, oldPassword: oPwd, newPassword: nPwd});
                        jxhr.done(function (response) {
                            if (response.success) {
                                self._closeUpdateModal();
                                self._listMembership();
                            } else {

                            }
                        });
                        jxhr.fail(function (reponse) {

                        });
                        jxhr.always(function () {
                            POS.showLoading(false);
                        });
                    } else {
                        self.$(".create-form .re-input").text(i18n.msg('pos.setting.membership.pwd.error'));
                        self.$(".create-form .pwd-required").show();
                    }
                });
                jxhr.fail(function (response) {

                });
                jxhr.always(function () {
                    POS.showLoading(false);
                });
            } else {
                POS.showLoading(true);
                jxhr = $.post(url, {id: id, password: nPwd});
                jxhr.done(function (response) {
                    if (response.success) {
                        self._closeUpdateModal();
                        self._listMembership();
                    } else {

                    }
                });
                jxhr.fail(function (reponse) {

                });
                jxhr.always(function () {
                    POS.showLoading(false);
                });
            }
        },
        _closeUpdateModal: function () {
            var self = this;
            self.$('.updateModal').modal("hide");
            self.$(".o-input").val("");
            self.$(".n-input").val("");
            self.$(".r-input").val("");
            self.$(".pwd-required").hide();
        },
        _rechargeHistorySortByName: function (e) {
            var self = this;
            var offset = 0;
            if (e) {
                offset = $(e.currentTarget).data("offset");
            }
            POS.showLoading(true);
            var rest = POS.getRestaurant(), result = $.post('/posMembership/searchRechargeHistory', {
                    restaurantId: rest.id,
                    companyId: rest.get('companyId'),
                    query: self.$('.memberSearch').val().trim(),
                    offset: offset,
                    sortBy: "membername"
                }
            );

            result.done(function (res) {
                self.$('.charge-panel').empty().append(res);
            });
            result.always(function () {
                POS.showLoading(false);
            });
        },

        _search: function () {
            this._changeTabPanel();
        },

        _createCharge: function (evt) {
            var result = $.post('/membership/createCharge', {
                id: $(evt.currentTarget).data('id'),
                webpos: true
            }), self = this;
            POS.showLoading(true);
            result.done(function (res) {
                self.$('.topupModal .modal-body').empty().append(res);
                self.$('.topupModal .modal-content').addClass("settingsModal");
                var option = $(".topupModal .credit-select").find("option:selected");
                $(".usableCredit label").text(option ? option.data("credit") : 0);
                self.$('.topupModal').modal('show');
            });

            result.fail(function (res) {

            });
            result.always(function () {
                POS.showLoading(false);
            });
            return false;
        },

        _createCoupon: function () {
            var result = $.post('/membership/creteCoupon', {
                restaurantId: POS.getRestaurant().id,
            }), self = this;
            POS.showLoading(true);
            result.done(function (res) {
                self.$('.couponModal .modal-body').empty().append(res);
                self.$('.couponModal .modal-content').addClass("settingsModal");
                var option = $(".couponModal .credit-select").find("option:selected");
                $(".usableCredit label").text(option ? option.data("credit") : 0);
                self.$('.couponModal').modal('show');
            });

            result.fail(function (res) {

            });
            result.always(function () {
                POS.showLoading(false);
            });
            return false;
            // var result = $.post('/couponManage/sendCouponTicket', {
            //     membershipId: $(evt.currentTarget).data('id'),
            //     generatedCode : "x0efArag"
            // }), self = this;
            // POS.showLoading(true);
            // result.done(function (res) {
            // });
            //
            // result.fail(function (res) {
            //
            // });
            // result.always(function () {
            //     POS.showLoading(false);
            // });
            // return false;
        },

        _createDeduct: function (evt) {
            var result = $.post('/membership/createDeduct', {
                id: $(evt.currentTarget).data('id'),
                webpos: true
            }), self = this;
            POS.showLoading(true);
            result.done(function (res) {
                self.$('.deductModal .modal-body').empty().append(res);
                self.$('.deductModal .modal-content').addClass("settingsModal");
                var option = $(".deductModal .credit-select").find("option:selected");
                $(".usableCredit label").text(option ? option.data("credit") : 0);
                self.$('.deductModal').modal('show');
            });

            result.fail(function (res) {

            });
            result.always(function () {
                POS.showLoading(false);
            });
            return false;
        },

        _disuseMembership: function (evt) {
            console.log("_disuseMembership");
            var self = this, jxhr, item = self.$(evt.currentTarget), membershipId = item.data("id");
            var membership = item.closest(".membership-tr");
            if (membership.hasClass("membership-disabled")) {
                if (confirm(i18n.msg('pos.setting.membership.disable.confirm', i18n.msg('pos.settings.discount.status.enabled')))) {
                    POS.showLoading(true);
                    jxhr = $.post("/membership/disuseMembership", {id: membershipId, disuse: false});
                    jxhr.done(function (response) {
                        if (response.success) {
                            item.closest(".membership-tr").removeClass("membership-disabled");
                            self._listMembership();
                        }
                    });
                    jxhr.fail(function (response) {
                        alert(i18n.msg('pos.setting.membership.connect.fail'));
                    });
                    jxhr.always(function () {
                        POS.showLoading(false);
                    });
                }
            } else {
                if (confirm(i18n.msg('pos.setting.membership.disable.confirm', i18n.msg('pos.settings.discount.status.disabled')))) {
                    POS.showLoading(true);
                    jxhr = $.post("/membership/disuseMembership", {id: membershipId, disuse: true});
                    jxhr.done(function (response) {
                        if (response.success) {
                            item.closest(".membership-tr").addClass("membership-disabled");
                            self._listMembership();
                        }
                    });
                    jxhr.fail(function (response) {
                        alert(i18n.msg('pos.setting.membership.connect.fail'));
                    });
                    jxhr.always(function () {
                        POS.showLoading(false);
                    });
                }
            }
            return false;
        },


        _closeModal: function () {
            this.$('.topupModal').modal('hide');
        },

        _submitCoupon: function () {
            let result = null, self = this;
            let couponForm = $(".coupon-form");
            let targetType = couponForm.find(".target-select").val();
            let params = {
                restaurantId: POS.getRestaurant().id,
                couponId: couponForm.find(".coupon-select").val(),
                targetType: targetType
            };

            if (targetType == "scheme") {
                params.schemeId = couponForm.find(".scheme-select").val()
            } else if (targetType == "member") {
                let info = couponForm.find(".memberInfo").val();
                if (!info || info == "") {
                    alert("请输入会员信息");
                    return false;
                }
                params.memberInfo = info
            }
            result = $.post('/membership/sendCouponGift', params);
            POS.showLoading(true);
            result.done(function (res) {
                if (res.success) {
                    self.$('.couponModal').modal('hide');
                    alert("优惠券赠送成功");
                    $('.modal-backdrop').remove();
                } else {
                    alert(res.errors);
                    return;
                }
            });

            result.fail(function () {
                alert('topup failed!');
            });
            result.always(function () {
                POS.showLoading(false);
            });
        },
        _saveTopup: function () {
            if (!_.every(this.$('input[name="chargeAmount"]'), function (item) {
                    var amount = Number($(item).val()), result = (_.isNumber(amount) && amount > 0);
                    return result;
                })) {
                alert(i18n.msg('pos.membership.topup.error.amount'));
                return;
            }
            let result = null, self = this;
            var params = {
                companyId: POS.getRestaurant().get('companyId'),
                restaurantId: POS.getRestaurant().id,
                currencyName: self.$(".topupModal .credit-select option:selected").text(),
                chargeType: self.$(".topupModal .chargetype-select option:selected").val()
            };
            _(this.$('.topupModal form').serializeArray()).forEach((field) => {
                params[field.name] = field.value;
            });
            if (confirm(i18n.msg('pos.setting.membership.charge.confirm', $('.bottom-border .usableCredit').text()[4] + $(this.$('input[name="chargeAmount"]')[0]).val()))) {

                result = $.post('/membership/charge', params);
                POS.showLoading(true);
                result.done(function (res) {
                    if (res.success) {
                        self.$('.topupModal').modal('hide');
                        self.render();
                        $('.modal-backdrop').remove();
                    } else {
                        alert(res.errors);
                        return;
                    }
                    if (!POS.getPrinterSetting().isPrintable()) {
                        return;
                    }
                    var data, membership = res.membership, before = res.amount,
                        time = moment().format('YYYY/MM/D HH:mm');
                    var creditItem = res.creditItem;
                    PrintService.printMembershipCredit(creditItem);
                });

                result.fail(function () {
                    alert('充值失败');
                });
                result.always(function () {
                    POS.showLoading(false);
                });
            }
        },

        _closeDeductModal: function () {
            this.$('.deductModal').modal('hide');
        },

        _saveDeduct: function () {
            if (!_.every(this.$('input[name="deductAmount"]'), function (item) {
                    var amount = Number($(item).val()), result = (_.isNumber(amount) && amount > 0);
                    return result;
                })) {
                alert(i18n.msg('pos.membership.topup.error.amount'));
                return;
            }
            let result = null, self = this;
            var params = {
                companyId: POS.getRestaurant().get('companyId'),
                restaurantId: POS.getRestaurant().id,
                currencyName: self.$(".deductModal .credit-select option:selected").text()
            };
            _(this.$('.deductModal form').serializeArray()).forEach((field) => {
                params[field.name] = field.value;
            });
            if (confirm(i18n.msg('pos.setting.membership.deduct.confirm', $('.bottom-border .usableCredit').text()[4] + $(this.$('input[name="deductAmount"]')[0]).val()))) {

                result = $.post('/membership/deduct', params);
                POS.showLoading(true);
                result.done(function (res) {
                    if (res.success) {
                        self.$('.deductModal').modal('hide');
                        self.render();
                        $('.modal-backdrop').remove();
                    } else {
                        alert('扣款失败，请稍后再试!');
                        return;
                    }
                    if (!POS.getPrinterSetting().isPrintable()) {
                        return;
                    }
                    var data, membership = res.membership, before = res.amount,
                        time = moment().format('YYYY/MM/D HH:mm');
                    var creditItem = res.creditItem;
                    PrintService.printMembershipCredit(creditItem, "deduct");
                });

                result.fail(function () {
                    alert('扣款失败，请稍后再试!');
                });
                result.always(function () {
                    POS.showLoading(false);
                });
            }
        },


        _rePrintExpend: function (evt) {
            var self = this, mId = $(evt.currentTarget).data("id"), creditId = $(evt.currentTarget).closest("tr").data("id"),
                url = "/membership/searchMembership", jxhr,
                before = $(evt.currentTarget).closest("td").siblings(".charge-amount").text(),
                time = $(evt.currentTarget).closest("td").siblings(".charge-dateCreated").text();
            POS.showLoading(true);
            jxhr = $.post(url, {id: mId, creditId: creditId});
            jxhr.done(function (res) {
                var data, creditItem = res.creditItem;
                data = PrinterConverterUtil.toMembershipReceipt(creditItem);
                if (typeof(chrome) !== 'undefined' && typeof(chrome.runtime) !== 'undefined') {
                    chrome.runtime.sendMessage(DbRecorder.read("chromeAppId"), {msg: data})
                }
            });
            jxhr.fail(function () {
                alert("topup failed");
            });
            jxhr.always(function () {
                POS.showLoading(false);
            });
        },
        _rePrintCharge: function (evt) {
            var self = this, mId = $(evt.currentTarget).data("id"), creditId = $(evt.currentTarget).closest("tr").data("id"),
                url = "/membership/searchMembership", jxhr,
                before = $(evt.currentTarget).closest("td").siblings(".charge-amount").text(),
                time = $(evt.currentTarget).closest("td").siblings(".charge-dateCreated").text();
            POS.showLoading(true);
            jxhr = $.post(url, {id: mId, creditId: creditId});
            jxhr.done(function (res) {
                var data, creditItem = res.creditItem;
                PrintService.printMembershipCredit(creditItem);
                data = PrinterConverterUtil.toMembershipReceipt(creditItem);
                if (typeof(chrome) !== 'undefined' && typeof(chrome.runtime) !== 'undefined') {
                    chrome.runtime.sendMessage(DbRecorder.read("chromeAppId"), {msg: data})
                }
            });
            jxhr.fail(function () {
                alert("topup failed");
            });
            jxhr.always(function () {
                POS.showLoading(false);
            });
        },
        _changeTabPanel: function (evt) {
            var type = "basic";
            if (evt) {
                type = $(evt.currentTarget).data('type');
                this.$('.memberList .nav li').removeClass('active');
                $(evt.currentTarget).addClass('active');
                this.$('.memberList .tab-pane').removeClass('active');
                this.$('.memberList .' + type + '-panel').addClass('active');
            } else {
                this.$('.memberList .nav li').removeClass('active');
                $('.memberList .nav li[data-type=basic]').addClass('active');
                this.$('.memberList .tab-pane').removeClass('active');
                this.$('.basic-panel').addClass('active');
            }

            if (type === "basic") {
                this._listMembership();
            } else if (type === "consume") {
                this._listExpenditureHistory();
            } else if (type === "charge") {
                this._listRechargeHistory();
            } else if (type === "rebate") {
                this._listRebateHistory();
            } else if (type === "deduct") {
                this._listDeductHistory();
            }

        },

        /*
         * creator: TWJ
         * createDate: 2014/9/26
         * update membership
         */
        _updateMembership: function (evt) {
            var self = this, rest = POS.getRestaurant(), companyId = rest.get('companyId'),
                mId = $(evt.currentTarget).closest(".membership-tr").data('id'), jxhr;
            POS.showLoading(true);
            jxhr = $.post("/pos/createMembership", {restaurantId: rest.id, companyId: companyId, mId: mId});
            jxhr.done(function (response) {
                if (self.modal) {
                    self.modal.close();
                }
                self.modal = new MembershipModalView({
                    title: i18n.msg("pos.settings.membership.updateMembership"),
                    save: i18n.msg("pos.membership.save"),
                    delete: i18n.msg('pos.delete')
                });
                self.modal.body(response);
                self.modal.$el.find('.modal-content').addClass("settingsModal");
                self.modal.$el.find('.btn-confirm').addClass("saveEdit-btn");
                self.modal.$el.find('.btn-delete').addClass("delete");
                self.modal.render();
                self.modal.on("delete", function () {
                    var memberId = self.modal.$('form').data('id'), url, jxhr;
                    if (confirm(i18n.msg('pos.setting.membership.delete.confirm')))
                        jxhr = $.post('/membership/delete', {id: memberId});
                    POS.showLoading(true);
                    jxhr.done(function (response) {
                        if (response.success) {
                            self.modal.close();
                            self._changeTabPanel();
                        }
                    });
                    jxhr.fail(function (response) {

                    });
                    jxhr.always(function () {
                        POS.showLoading(false);
                    });
                    return false;
                });
                self.modal.on("confirm", function () {
                    var form = self.modal.$('form'), jxhr;
                    if (form.hasClass('errors')) {
                        return false;
                    }
                    jxhr = $.post("/membership/update", form.serialize());
                    POS.showLoading(true);
                    jxhr.done(function (response) {
                        if (response.success) {
                            self.modal.close();
                            self._changeTabPanel();
                            //modal.model.set(response.membership);
                        } else {
                            self.modal.showFieldError(response.errors);
                        }
                    });
                    jxhr.fail(function (response) {
                        alert(i18n.msg('pos.action.failure.save'));
                    });
                    jxhr.always(function () {
                        POS.showLoading(false);
                    });
                    return false;
                });
            });
            jxhr.fail(function (response) {
                alert(i18n.msg('pos.action.failure.save'));
            });
            jxhr.always(function () {
                POS.showLoading(false);
            });
        },

        /*
         * creator: Tuxiang
         * createDate: 2014/6/15
         * create membership
         */
        _createMembership: function (evt) {
            var that = this;
            var rest = POS.getRestaurant();
            var companyId = rest.get('companyId');
            var currentTarget = $(evt.currentTarget);
            var recommendId;
            if (Number(currentTarget.data("schemeCount")) <= 0) {
                alert(i18n.msg("pos.settings.membership.createMembership.error"));
                return false;
            }
            POS.showLoading(true);
            if (currentTarget.hasClass('recommend-membership-btn')) {
                recommendId = currentTarget.data('id');
            }
            $.post("/pos/createMembership", {
                restaurantId: rest.id,
                companyId: companyId,
                recommendId: recommendId
            }, function (response) {
                POS.showLoading(false);
                if (that.modal) {
                    that.modal.remove();
                }
                that.modal = new MembershipModalView({
                    title: i18n.msg("pos.settings.membership.createMembership.label"),
                    save: i18n.msg("pos.membership.create")
                });
                that.modal.$el.find('.modal-content').addClass("settingsModal");
                that.modal.$el.find('.btn-confirm').addClass('saveCreate-btn');
                that.modal.body(response);
                that.modal.render({backdrop: "static"});
                that.modal.$("#randomCardNo").on("click", function () {
                    var restId = rest.id + "";
                    var cardNum = "";
                    var zeroNum = "";
                    if (restId.length >= 4) {
                        cardNum = restId + parseInt(Math.random() * 9000 + 1000);
                    }
                    else {
                        for (var i = 0; i < (4 - restId.length); i++) {
                            zeroNum = zeroNum + "0"
                        }
                        cardNum = zeroNum + restId + parseInt(Math.random() * 9000 + 1000);
                    }
                    that.modal.$('.card-no-input').val(cardNum)
                });
                that.modal.on("confirm", function () {
                    var form = that.modal.$('form'), url, jxhr;
                    if (form.hasClass('errors')) {
                        return false;
                    }
                    POS.showLoading(true);
                    jxhr = $.post("/membership/save", form.serialize());
                    jxhr.done(function (response) {
                        if (response.success) {
                            that.modal.close();
                            that._changeTabPanel();
                            //modal.model.set(response.membership);
                        } else {
                            that.modal.showFieldError(response.errors);
                        }
                    });
                    jxhr.fail(function (response) {
                        alert(i18n.msg('pos.action.failure.save'));
                    });
                    jxhr.always(function () {
                        POS.showLoading(false);
                    });
                    return false;
                });
            });
        },

        _listMembership: function (e) {
            var offset = 0, self = this;
            if (e) {
                offset = $(e.currentTarget).data("offset");
            }
            POS.showLoading(true);
            var rest = POS.getRestaurant(), result = $.post('/posMembership/searchMemberships', {
                    restaurantId: rest.id,
                    companyId: rest.get('companyId'),
                    query: self.$('.memberSearch').val() ? self.$('.memberSearch').val().trim() : "",
                    offset: offset
                }
            );

            result.done(function (res) {
                self.$('.basic-panel').empty().append(res);
            });
            result.always(function () {
                POS.showLoading(false);
            });
        },

        _listExpenditureHistory: function (e) {
            var offset = 0, self = this;
            if (e) {
                offset = $(e.currentTarget).data("offset");
            }
            POS.showLoading(true);
            var rest = POS.getRestaurant(), result = $.post('/posMembership/searchExpenditureHistory', {
                    restaurantId: rest.id,
                    companyId: rest.get('companyId'),
                    query: self.$('.memberSearch').val().trim(),
                    offset: offset
                }
            );

            result.done(function (res) {
                self.$('.consume-panel').empty().append(res);
            });
            result.always(function () {
                POS.showLoading(false);
            });
        },

        _listRechargeHistory: function (e) {
            var offset = 0, self = this;
            if (e) {
                offset = $(e.currentTarget).data("offset");
            }
            POS.showLoading(true);
            var rest = POS.getRestaurant(), result = $.post('/posMembership/searchRechargeHistory', {
                    restaurantId: rest.id,
                    companyId: rest.get('companyId'),
                    query: self.$('.memberSearch').val().trim(),
                    offset: offset
                }
            );

            result.done(function (res) {
                self.$('.charge-panel').empty().append(res);
            });
            result.always(function () {
                POS.showLoading(false);
            });
        },

        _listRebateHistory: function (e) {
            console.log("_listRebateHistory");
            var offset = 0, self = this;
            if (e) {
                offset = $(e.currentTarget).data("offset");
            }
            POS.showLoading(true);
            var rest = POS.getRestaurant(), result = $.post('/posMembership/searchRebateHistory', {
                    restaurantId: rest.id,
                    companyId: rest.get('companyId'),
                    query: self.$('.memberSearch').val().trim(),
                    offset: offset
                }
            );

            result.done(function (res) {
                self.$('.rebate-panel').empty().append(res);
            });
            result.always(function () {
                POS.showLoading(false);
            });
        },

        _listDeductHistory: function (e) {
            console.log("_listDeductHistory");
            var offset = 0, self = this;
            if (e) {
                offset = $(e.currentTarget).data("offset");
            }
            POS.showLoading(true);
            var rest = POS.getRestaurant(), result = $.post('/posMembership/searchDeductHistory', {
                    restaurantId: rest.id,
                    companyId: rest.get('companyId'),
                    query: self.$('.memberSearch').val().trim(),
                    offset: offset
                }
            );

            result.done(function (res) {
                self.$('.deduct-panel').empty().append(res);
            });
            result.always(function () {
                POS.showLoading(false);
            });
        },

        _changeTargetType: function (evt) {
            var val = $(evt.currentTarget).val();
            var membersearch = $(".create-coupon .member-info");
            var schemeType = $(".create-coupon .scheme-type");
            switch (val) {
                case "all":
                    membersearch.addClass("hidden");
                    schemeType.addClass("hidden");
                    break;
                case "member":
                    membersearch.removeClass("hidden");
                    schemeType.addClass("hidden");
                    break;
                case "scheme":
                    membersearch.addClass("hidden");
                    schemeType.removeClass("hidden");
                    break;
            }
        },
        _changeTopupType: function (evt) {
            var option = $(evt.currentTarget).find("option:selected");
            this.$(".usableCredit label").text(option.data("credit"));
        },

        _changeDeductType: function (evt) {
            var option = $(evt.currentTarget).find("option:selected");
            this.$(".usableCredit label").text(option.data("credit"));
        },

        _recommendMembership: function (evt) {
            this._createMembership(evt);
        }

    });
};

let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/view/settings/MembershipView.js